import React from 'react';
import { slugify } from '@/utils/helpers';

const JumplinkFallback = ({ jumplinkLabel = '' }: any) => {
  const identifier = React.useMemo(() => slugify({ label: jumplinkLabel }), [jumplinkLabel]);
  return <div id={identifier} />;
};

export default JumplinkFallback;
